const toMinutes = (time: string): number => {
  const [h, m] = time.split(":").map(Number);
  return (h ?? 0) * 60 + (m ?? 0);
};

const hourEndToMinutes = (time: string): number => {
  return time === "00:00" ? 24 * 60 : toMinutes(time);
};

const toTimeString = (minutes: number): string => {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  const result = `${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}`;
  if (result === "24:00") return "00:00";
  return result;
};

export { hourEndToMinutes, toMinutes, toTimeString };
